/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentFeature } from './DocumentFeature';
import {
	DocumentFeatureFromJSON,
	DocumentFeatureFromJSONTyped,
	DocumentFeatureToJSON,
	DocumentFeatureToJSONTyped,
} from './DocumentFeature';
import type { ValidationResult } from './ValidationResult';
import {
	ValidationResultFromJSON,
	ValidationResultFromJSONTyped,
	ValidationResultToJSON,
	ValidationResultToJSONTyped,
} from './ValidationResult';

/**
 *
 * @export
 * @interface EasyClaimDocumentValidationResult
 */
export interface EasyClaimDocumentValidationResult {
	/**
	 *
	 * @type {DocumentFeature}
	 * @memberof EasyClaimDocumentValidationResult
	 */
	feature?: DocumentFeature;
	/**
	 *
	 * @type {ValidationResult}
	 * @memberof EasyClaimDocumentValidationResult
	 */
	validationResult?: ValidationResult;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimDocumentValidationResult
	 */
	title?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimDocumentValidationResult
	 */
	description?: string | null;
}

/**
 * Check if a given object implements the EasyClaimDocumentValidationResult interface.
 */
export function instanceOfEasyClaimDocumentValidationResult(
	value: object
): value is EasyClaimDocumentValidationResult {
	return true;
}

export function EasyClaimDocumentValidationResultFromJSON(
	json: any
): EasyClaimDocumentValidationResult {
	return EasyClaimDocumentValidationResultFromJSONTyped(json, false);
}

export function EasyClaimDocumentValidationResultFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EasyClaimDocumentValidationResult {
	if (json == null) {
		return json;
	}
	return {
		feature: json['feature'] == null ? undefined : DocumentFeatureFromJSON(json['feature']),
		validationResult:
			json['validationResult'] == null
				? undefined
				: ValidationResultFromJSON(json['validationResult']),
		title: json['title'] == null ? undefined : json['title'],
		description: json['description'] == null ? undefined : json['description'],
	};
}

export function EasyClaimDocumentValidationResultToJSON(
	json: any
): EasyClaimDocumentValidationResult {
	return EasyClaimDocumentValidationResultToJSONTyped(json, false);
}

export function EasyClaimDocumentValidationResultToJSONTyped(
	value?: EasyClaimDocumentValidationResult | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		feature: DocumentFeatureToJSON(value['feature']),
		validationResult: ValidationResultToJSON(value['validationResult']),
		title: value['title'],
		description: value['description'],
	};
}
